<template>
  <v-col :cols="cols" :class="inner_cpnt_class + ' center-page-column-cmpt-lmnt'" no-gutters>
    <slot></slot>
  </v-col>
</template>

<script>
export default {
  name: "CenterPageColumn",
  props: {
    has_nav_bar: {
      type: Boolean,
      default: false,
    },
    cpnt_class: {
      type: String,
      default: ""
    },
    outlined:{
      type: Boolean,
      default: true,
    },
    cols:{
      type: [String,Number],
      default: "8"
    }
  },
  computed:{
      inner_cpnt_class(){
          var cls = 'text-center ' + (this.outlined?'outlined':'') + ' ml-16_6p ';
          if(this.has_nav_bar == true){
              cls = cls + " col-has-nav-bar";
          }
          return cls + " " + this.cpnt_class;
      }
  }
};
</script>